import React, { Component, useState } from "react";
import Slider from "react-slick";
import styled, { withTheme } from 'styled-components';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { ifProp, theme, withProp } from 'styled-tools';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';


// images
// import SlickImageRoulette from '../../images/Roulette slider img.jpg';
// import DiscoverEdgeBg from '../../images/Casino Heading bg.png';
// import LivePoker from '../../images/newimagecarousel2.jpeg';
import LiveJackpot from '../../images/newimagecarousel1.jpeg'
import LiveAndarBahar from '../../images/AndharBahar1103.png';
import LeftArrow from "../../images/Vector 196.png";
import RightArrow from "../../images/Vector 195.png";
import TeenPatti1 from "../../images/teenpattiNormal.jpg";
import TeenPatti2 from "../../images/TeenpattiImage.jpg";
import AndharBahar from "../../images/Andar-bahar.jpg";


import Modal from "src/components/Modal";
import CasinoGames from "../eu-content/casino-page/casino-slider-Games";
import config from "src/config/config";
import { color, bgcolor } from '../../sass-files/variable';
import { Link } from "react-router-dom";
import cookieUtil from "src/util/cookieUtil";
import { ECookieName } from "src/util/utilModel";
import Intl from '../common/Intl'

import { SRTM } from 'src/util/sportradarEvent';
import { withAppContext } from "src/store/initAppContext";



const Baccarat = `${'static/Image/baccarat.jpg'}`
// const BlackJack = `${'static/Image/black_jack.jpg'}`
// const DreamCatcher = `${'static/Image/dream_catcher.jpg'}`
// const teenpattiPlus = `${'/static/Image/teenpatti.jpg'}`
const Poker1 = `${'static/Image/poker_laptop.jpg'}`

// const { secondarycolor } = color
// const { loginbg } = bgcolor
// const { loginbghover } = bgcolor
const { signupbghover } = bgcolor
const isAuth = cookieUtil.get(ECookieName.COOKIE_TOKEN);
function CenterMode(props) {
  const AllGame = [

    {
      id: 60,
      type: 'TEENPATTIPLUS',
      game: "TEENPATTIPLUS2020",
      // url: 'http://google.com',
      imgsrc: Poker1,
      platformCode: "AgTeenpatti",
      code: "",
    },

    // {
    //     id: 6,
    //     type: 'EVOLUTION',
    //     game: "poker",
    //     // url: 'http://google.com',
    //     imgsrc: Poker1,
    //     platformCode: "WACS",
    //     code: "EVOLUTION-poker-lobby",
    // },

    {
      id: 1,
      type: 'EVOLUTION',
      game: "baccarat",
      // url: 'http://google.com',
      platformCode: "WACS",
      code: "EVOLUTION-baccarat-lobby",
      imgsrc: Baccarat
    },
    {
      id: 59,
      type: 'JACKPOT',
      game: "JACKPOT",
      catagoryName: "All",
      // url: 'http://google.com',
      imgsrc: LiveJackpot,
      platformCode: "WACS",
      code: "EZUGI-BetOnTeenPatti_227101",
    },
    {
      id: 9,
      type: 'super-spade',
      game: "andar bahar",
      catagoryName: "Andar Bahar",
      // url: 'http://google.com',
      imgsrc: LiveAndarBahar,
      platformCode: "WACS",
      code: "Ab1lkajgh7trgh20",
    }
  ]
  {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 2,
      centerMode: true,
      centerPadding: '25%',
      autoplay: false,

    };
    const [modal, setModal] = useState(false);
    const handleClose = () => setModal(false);

    const { app: { brandId } } = props

    const toggleModal = (gameName) => {
      setSelectedGame([gameName])
      setModal(!modal);

      //for sport Radar
      if (gameName && typeof gameName === 'object') {
        SRTM.retargetCasinoEvent(brandId, {
          id: gameName.id || '',
          name: gameName.game,
          category: gameName.type,
          image: gameName.imgsrc
        })
      }


    }

    const [selectedGame, setSelectedGame] = useState([]);


    AllGame.map((item, index) => {
      <p>{item.game}</p>
      // debugger
    })

    return (
      <TopSectionWrapper>
        <FirstColoumn>
          <Slidername>
            <LiveDealer>
              {/* <img src={DiscoverEdgeBg} alt="first image"  /> */}
              <h4><Intl langKey="TITLE@LIVE_DEALER" /></h4>
            </LiveDealer>

            <Slider {...settings}>

              <Wrapper1>
                <Link to="/" className="colfirst">
                  {/* <img src={`${config.imageS3Host}${TeenPatti1}`} /> */}
                  <Intl langKey="SLIDERIMAGE@TEENPATTI1">
                    {(message: string) => {
                      return (
                        <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%" placeholder={<PlaceholderImage />} />
                      );
                    }}
                  </Intl>
                  <span>
                    <div className="overlay">
                      <div className="buttons">
                        {
                          cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                            <button onClick={() => toggleModal(AllGame[0])}><Intl langKey="TITLE@PLAY" /></button>
                          </PlayButton> : <DemoButton>
                            <button onClick={() => toggleModal(AllGame[0])}><Intl langKey="TITLE@DEMO" /></button>
                          </DemoButton>
                        }


                      </div>
                    </div>
                  </span>
                </Link>
              </Wrapper1>
              {/* <Wrapper2 onClick={() => toggleModal(AllGame[2])}>
                <span>
                  <p>live</p>
                  <h4>jackpot</h4>
                </span>
            </Wrapper2> */}
              <Wrapper3>
                <Link to="/" className="colsecond">
                  {/* <img src={`${config.imageS3Host}${AndharBahar}`} /> */}
                  <Intl langKey="SLIDERIMAGE@TEENPATTI3">
                    {(message: string) => {
                      return (
                        <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%" placeholder={<PlaceholderImage />} />
                      );
                    }}
                  </Intl>
                  <span>
                    <div className="overlay">
                      <div className="buttons">
                        {
                          cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                            <button onClick={() => toggleModal(AllGame[3])}><Intl langKey="TITLE@PLAY" /></button>
                          </PlayButton> : <DemoButton>
                            <button onClick={() => toggleModal(AllGame[3])}><Intl langKey="TITLE@DEMO" /></button>
                          </DemoButton>
                        }


                      </div>
                    </div>
                  </span>
                </Link>
              </Wrapper3>
              <Wrapper4>
                <Link to="/" className="colthird">
                  {/* <img src={`${config.imageS3Host}${TeenPatti2}`} /> */}
                  <Intl langKey="SLIDERIMAGE@TEENPATTI2">
                    {(message: string) => {
                      return (
                        <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%" placeholder={<PlaceholderImage />} />
                      );
                    }}
                  </Intl>
                  <span>
                    <div className="overlay">
                      <div className="buttons">
                        {
                          cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                            <button onClick={() => toggleModal(AllGame[0])}><Intl langKey="TITLE@PLAY" /></button>
                          </PlayButton> : <DemoButton>
                            <button onClick={() => toggleModal(AllGame[0])}><Intl langKey="TITLE@DEMO" /></button>
                          </DemoButton>
                        }


                      </div>
                    </div>
                  </span>
                </Link>
              </Wrapper4>
              {/* <Wrapper5 onClick={() => toggleModal(AllGame[2])}>
                <span>
                  <p>live</p>
                  <h4>jackpot</h4>
                </span>
            </Wrapper5> */}

            </Slider>
            <Modal show={modal} handleClose={handleClose}>
              <CasinoGames modalState={modal} data={selectedGame} open={'true'} />
            </Modal>
          </Slidername>
        </FirstColoumn>
      </TopSectionWrapper>
    );
  }
};

export default withAppContext(CenterMode)

const LiveDealer = styled.div`
 font-size: 20px; 
 margin:0px;
 padding:0px;
 background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.liveDealerCasinoBg')});
//  bottom:50px;
//  position: relative;
 height: 99px;
 background-size: cover;
 background-position: center;
 background-repeat: no-repeat;
 display: flex;
 align-items: flex-end;

 h4{
    margin: 0px;
    color: ${theme('palette.homeTittleTexts')};
    text-transform: uppercase;
    font-size: 30px;
    padding-left: 20px;
    letter-spacing: ${theme('palette.homeLiveDealerTittleSpacing')};
    font-weight: bold;

    @media only screen and (min-width: 1800px){
        font-size: 35px;
    }
 }
`;

const Slidername = styled.div`

  // height:252px;
  width:100%;
  cursor:pointer;

  div {
    display:flex;
    color: #fff;
    padding: 0px 0px 0px 1px;
  }

  img{
    // top:25px;
    width:100%;
   }

.slick-arrow{
    color: black;
            }


            .slick-next:before {
              font-size:0px;
            }

            .slick-prev:before{
              font-size:0px;
            }

.slick-prev{
   
    
    z-index: 100;
    left: 0px !important;
    background: ${theme('palette.sliderHP')};
    position: absolute;
    bottom: 50px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    height: 60px;
    width: 30px;
    border: none;
    background-image:url(${LeftArrow});
    background-repeat: no-repeat;
    content: none;
    /* background-color: #000000; */
    font-size:0px;
}

.slick-next {
   
    z-index: 100;
    right: 5px !important;
    background: ${theme('palette.sliderHP')};
    position: absolute;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    height: 60px;
    width: 30px;
    border: none;
    background-image:url(${RightArrow});
    background-repeat: no-repeat;
    /* background-color: #000000; */
    content: none;
    font-size:0px;
}

.slick-list{
  // height:215px;
  background: black;
  background: ${theme('palette.liveDealerCarausalBg')};

  .slick-slide {
    margin: ${theme('palette.liveDealerCarausalSliderMargin')};
  }
}


.slick-slider {
  z-index: 1;
  position: relative;
  // height: 220px;
  // bottom: 50px;
  width:100%;
  background:#002150;    
}

.ul slick-dots {
    display:none;
}

.slick-arrow slick-prev slick-disabled{
    color:black;
    display: none;
}

.slick-arrow slick-next{
    color: green;
}


`;


const Wrapper1 = styled.div`

span{
  display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    text-transform: uppercase;
    // height: 214px;
    // padding-left: 60px;
}

h4{
  margin:0px;
  font-size: 25px;
  font-weight: 500;
  width: fit-content;
}

p{
      color: #33abaf;
      margin-bottom: 7px;
      font-size: 21px;
      width: fit-content;
}
`;

const Wrapper3 = styled.div`

span{
  display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    text-transform: uppercase;
    // height: 214px;
    // padding-left: 60px;
}

h4{
  margin:0px;
  font-size: 25px;
  font-weight: 500;
  width: fit-content;

}

p{
      color: #33abaf;
      margin-bottom: 7px;
      font-size: 21px;
      width: fit-content;
}
`;

const Wrapper4 = styled.div`

span{
  display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    text-transform: uppercase;
    // height: 214px;
    // padding-left: 60px;
}

h4{
  margin:0px;
  font-size: 25px;
  font-weight: 500;
  width: fit-content;

}

p{
      color: #33abaf;
      margin-bottom: 7px;
      font-size: 21px;
      width: fit-content;
}

`;

export const PlayButton = styled.div`
 
    transform: skew(340deg);
    border: ${theme('palette.DemoButtonBorder')};
    margin-left: 10px;
    background: ${theme('palette.DemoButtonBg')};
    box-shadow: 3px 5px 4px rgba(0, 0, 0, 0.25);
    transition: color 0.1s linear 0s;
    

    :hover {
        background: ${theme('palette.primary-background-color-linear-new')};
        transition: color 0.1s linear 0s;
    }

    button {
        width: 80px;
        text-align: center;
        display: block;
        text-decoration: none;
        padding: 10px 0px;
        font-size: 14px;
        transform: skew(-340deg);
        color: ${theme('palette.DemoButtonColor')};
        text-transform: uppercase;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
`;

export const DemoButton = styled.div`
    transform: skew(340deg);
    border: ${theme('palette.DemoButtonBorder')};
    margin-left: 10px;
    background: ${theme('palette.DemoButtonBg')};
    box-shadow: 3px 5px 4px rgba(0, 0, 0, 0.25);
    transition: color 0.1s linear 0s;
    width: fit-content;

    :hover {
        // background: ${signupbghover};
        background: ${theme('palette.primary-background-color-linear-new')};
        transition: color 0.1s linear 0s;
    }

    button {
        width: 80px;
        text-align: center;
        display: block;
        text-decoration: none;
        padding: 10px 0px;
        font-size: 14px;
        transform: skew(-340deg);
        color: ${theme('palette.DemoButtonColor')};
        text-transform: uppercase;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
`;

const FirstColoumn = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;

    a {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        /* border: 1px solid #333;
        margin: 5px 5px 0px 0px; */
        position: relative;
        cursor: default;

        img {
            max-width: 100%;
            width: 100%;
        }
    }

    a:hover .overlay {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }

    .colfirst {
        // height: 214px;
        // background-image: url(${config.imageS3Host}${TeenPatti1});
        align-items: flex-end;

        h4 {
            bottom: 30px;
        }
    }

    .colsecond {
        // height: 214px;
        // background-image: url(${config.imageS3Host}${TeenPatti2});
        align-items: flex-end;

        h4 {
            bottom: 30px;
        }
    }

    .colthird {
        // height: 214px;
        // background-image: url(${config.imageS3Host}${AndharBahar});
        align-items: flex-end;

        h4 {
            bottom: 30px;
        }
    }

`;

const TopSectionWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;

    .overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0.9;
        background: ${theme('palette.overlayBGColor')};
        overflow: hidden;
        width: 100%;
        height: 100%;
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
        -webkit-transition: .5s ease;
        transition: .5s ease;
      }
      
      .buttons {
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
`;

